import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { NightwebUtil } from '../utils';
import { OrganizationSettingsService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard  {
  loggedInUser: any;
  constructor(
    private router: Router,
    private nightwebUtil: NightwebUtil,
    private organizationSettings: OrganizationSettingsService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.loggedInUser = this.nightwebUtil.getLoggedInUser();
    const [routeData] = Object.keys(route.data).map((key) => route.data[key]);
    const isDeviceAdmin = this.nightwebUtil.isDeviceAdmin();
    const url = state.url;
    const resourceName = routeData?.['resourceName'];
    const accessType = routeData?.['accessType'] ?? 'R';

    if (!this.loggedInUser) {
      this.router.navigate(['/login']);
      return false;
    }

    if (this.nightwebUtil.isEndUser()) {
      if (this.nightwebUtil.isEndUserUrlAllowed(url)) {
        return true;
      }
      return this.router.parseUrl(this.nightwebUtil.getEndUserHomePath());
    }

    if (isDeviceAdmin) {
      // Allow only /devices route for device admins
      if (url === '/devices') {
        return true;
      } else {
        return this.router.createUrlTree(['/devices']);
      }
    }

    /** Watch Themes catalog: NightWatch Admin only — never grant via RBAC. */
    if (resourceName === 'Watch Themes') {
      if (this.nightwebUtil.isSuperAdmin()) {
        return true;
      }
      this.router.navigate(['/end-users']);
      return false;
    }

    /** Monitored Users: org module flag only — never grant via RBAC. */
    if (resourceName === 'Monitored Users') {
      if (this.organizationSettings.isThreatPairModuleOn()) {
        return true;
      }
      this.router.navigate(['/end-users']);
      return false;
    }

    if (this.nightwebUtil.isAccessible(resourceName, accessType)) {
      return true;
    }

    this.router.navigate(['/end-users']);
    return false;
  }
}
